import React, { useState, useEffect } from 'react';
import IframeResizer from 'iframe-resizer-react';
import { Loader } from '@ublend-npm/aulaui-next';
import { fetchOEmbedMeta, OEmbedMeta } from '../../lib/fetchOEmbedMeta';
import {
  LoaderContainer,
  LoadingErrorContainer,
} from './EmbeddedIframe.styled';
import { useAulaEditorContext } from '../../EditorContext';

export type EmbeddedIframeProps = {
  src: string;
  title: string;
  minHeight: number | undefined;
  maxHeight: number | undefined;
  width: string | undefined;
  minWidth: number | undefined;
  maxWidth: number | undefined;
  oEmbedApi: string | undefined;
  oEmbedUrl: string | undefined;
};

export const EmbeddedIframe = ({
  src,
  title,
  minHeight,
  maxHeight,
  width,
  minWidth,
  maxWidth,
  oEmbedApi,
  oEmbedUrl,
}: EmbeddedIframeProps) => {
  const [loading, setLoading] = useState(true);
  const [failedToLoad, setFailedToLoad] = useState(false);
  const [iframeHTML, setIframeHTML] = useState('');

  const {
    config: { apiUrl },
  } = useAulaEditorContext();

  useEffect(() => {
    if (oEmbedApi && oEmbedUrl && apiUrl) {
      fetchOEmbedMeta(oEmbedApi, oEmbedUrl, apiUrl)
        .then(({ html }: OEmbedMeta) => {
          setIframeHTML(`
            <script type="text/javascript" charset="utf-8" async src='https://cdnjs.cloudflare.com/ajax/libs/iframe-resizer/3.5.15/iframeResizer.contentWindow.min.js'></script>
            ${html}
          `);
        })
        .catch(() => setFailedToLoad(true));
    }
  }, [src, oEmbedApi, oEmbedUrl, apiUrl]);

  // Render the loader when we have a oEmbedApi but the HTML was not fetched yet
  if (oEmbedApi && !iframeHTML) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }

  if (failedToLoad) {
    return (
      <LoadingErrorContainer>
        Failed to load the resource content!
      </LoadingErrorContainer>
    );
  }

  return (
    <>
      {loading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : null}
      <IframeResizer
        src={src}
        srcDoc={iframeHTML || undefined}
        title={title}
        frameBorder={0}
        contentEditable={false}
        scrolling={!iframeHTML}
        checkOrigin={false}
        minHeight={minHeight}
        maxHeight={maxHeight}
        minWidth={minWidth}
        maxWidth={maxWidth}
        width={width}
        onLoad={() => setTimeout(() => setLoading(false), 500)}
        style={{ display: loading ? 'none' : 'inherit' }}
        data-testid="collapsible-embedded-iframe"
        sizeHeight
      />
    </>
  );
};
